import React from 'react';
import SubscriptionMainCardSkeletonDesktop from './SubscriptionMainCardSkeletonDesktop';
import { SubscriptionMainCardSkeletonMobile } from './SubscriptionMainCardSkeletonMobile';

const SubscriptionMainCardSkeleton = () => (
  <>
    <SubscriptionMainCardSkeletonDesktop />
    <SubscriptionMainCardSkeletonMobile />
  </>
);

export default SubscriptionMainCardSkeleton;
